import { BLOCKS } from '@contentful/rich-text-types'
export default {
  [BLOCKS.HR]: (_, key, h) =>
    h('hr', { key, class: 'border-0 h-px w-full bg-gray m-0' }, {}),
}
